// pages/NotFound.tsx
import React from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export default function NotFound() {
  return (
    <section className="min-h-screen bg-white flex items-center justify-center py-16 px-6">
      <div className="max-w-md w-full text-center">
        {/* 404 with Gradient */}
        <h1
          className="text-[150px] md:text-[200px] leading-none bg-gradient-to-r from-[#C49355] to-[#E8B46A] bg-clip-text text-transparent mb-4"
          style={{
            fontFamily: "'Times New Roman', Times, serif",
            fontWeight: 400,
          }}
        >
          404
        </h1>

        {/* Heart Divider */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-16 h-px bg-gray-300"></div>
          <Heart className="w-4 h-4 text-[#C49355]" fill="#C49355" />
          <div className="w-16 h-px bg-gray-300"></div>
        </div>

        {/* Message */}
        <h2
          className="text-2xl md:text-3xl text-gray-700 mb-4"
          style={{
            fontFamily: "'Times New Roman', Times, serif",
          }}
        >
          Page Not Found
        </h2>

        <p
          className="text-gray-500 mb-10"
          style={{
            fontFamily: "'Times New Roman', Times, serif",
          }}
        >
          Oops! This page seems to have wandered off. Let's get you back to the
          celebration.
        </p>

        {/* Back to Home Button */}
        <Link
          to="/"
          className="inline-block bg-[#3d3d3d] hover:bg-[#2d2d2d] text-white px-12 py-3 text-sm transition-colors duration-300"
        >
          Back to Home
        </Link>
      </div>
    </section>
  );
}
